import {Component, Inject, Input, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ServerService} from "../../../../services/server.service";
import {DialogService} from "../dialog.service";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {UserFactory} from "../../../../models/User";

@Component({
   selector: 'app-dialog-cambia-password',
   templateUrl: './dialog-cambia-password.component.html',
   styleUrls: ['./dialog-cambia-password.component.scss']
})
export class DialogCambiaPasswordComponent implements OnInit {

   frmGrpUser: UntypedFormGroup = new UntypedFormGroup({
      password: new UntypedFormControl('', Validators.required),
      confirm_password: new UntypedFormControl('', Validators.required),
   }, { validators: this.checkPasswords });

   public hidepw = true;
   public hidepw2 = true;

   constructor(private serverSrv:ServerService,
               private dialogSrv:DialogService,
               private userFactory:UserFactory,
               @Inject(MAT_DIALOG_DATA) public data: {user_id: number}) {

   }

   ngOnInit(): void {
   }

   clickCambioPsw() {
      if(this.frmGrpUser.valid){
         this.userFactory.setPassword(this.data.user_id, this.frmGrpUser.value["password"]).then(res=>{
            this.dialogSrv.closeAll();
            this.dialogSrv.showSuccess({msg:"Password cambiata con successo"})
         }).catch(err=>{
            this.dialogSrv.closeAll();
            this.dialogSrv.showError({err: err, title:"Impossibile cambiare la password"})
         })
      }else{
         this.frmGrpUser.markAllAsTouched()
      }
   }

   checkPasswords(control: AbstractControl) {
      const password = control.get('password');
      const confirm_password = control.get('confirm_password');
      let has_err = password && confirm_password && password.value !== confirm_password.value ? { not_same_pswd: true } : null;
      if (has_err) confirm_password?.setErrors({not_same_pswd: true});
      else confirm_password?.setErrors(null);
      return has_err;
   };
}
